import { render, staticRenderFns } from "./max-phone-number-warning.vue?vue&type=template&id=c4a32798"
import script from "./max-phone-number-warning.vue?vue&type=script&lang=js"
export * from "./max-phone-number-warning.vue?vue&type=script&lang=js"
import style0 from "./max-phone-number-warning.vue?vue&type=style&index=0&id=c4a32798&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports